import React from 'react';
import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import CompanyLogo from 'components/v2/PageElements/CompanyLogo';
import { BANNER_LINE_HEIGHT } from 'components/v2/Company/Banner';

import { withPermissionsAndPreferences } from 'lib/v1/hooks';

export const mainNavWidth = '5.25rem';

const NavContainer = styled(Box)(({ bannerEnabled, theme }) => ({
  position: 'fixed',
  zIndex: 2,
  background: theme.palette.navbar.main,
  minHeight: '100vh',
  padding: '0',
  width: mainNavWidth,
  ...(bannerEnabled && { top: BANNER_LINE_HEIGHT }),
}));

const ChannelStrip = styled(Box)({
  height: 'calc(100vh - 90px)',
  display: 'flex',
  flexDirection: 'column',
});

const NavWrapper = ({ children, preferences, profile }) => {
  const bannerEnabled = profile?.company?.banner?.enabled;

  return (
    <NavContainer component="nav" bannerEnabled={bannerEnabled}>
      <CompanyLogo />
      <ChannelStrip>{children}</ChannelStrip>
    </NavContainer>
  );
};

export default withPermissionsAndPreferences(NavWrapper);
